<script lang="ts">
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import * as _ from "underscore";
    import type { UserCreationRequest } from "../../../../../admin-service-typescript-client/models/UserCreationRequest";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { organisationStore } from "../../../../store";
    // import { mapRolesToPermission } from "../../../../GlobalHelper/Permissions";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import PermissionsTable from "./Components/PermissionsTable.svelte";

    const navigate = useNavigate();

    let newUser: UserCreationRequest = {
        active: false,
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        permissions: [],
        organisationId: "0",
    };

    let passwordControl = "";
    let individualPermissions = [];
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    $: validPassword =
        (newUser.password.length > 7 && newUser.password === passwordControl) ||
        passwordControl === "";

    // const changePermissionsHandler = (permissions: Permission[]) => {
    //     individualPermissions = permissions;
    // };

    // $: {
    //     newUser.permissions = _.uniq(
    //         (newUser.permissions = mapRolesToPermission(
    //             $usersStore.roles
    //         ).concat(individualPermissions))
    //     );
    // }

    const getRolesPermissionMapping = async () => {
        // await $user.updateToken().then(async () => {
        //     await ApiClient.getInstance($user)
        //         .userClient.get()
        //         .then((roles) =>
        //             usersStore.update((usersStore) => {
        //                 return {
        //                     ...usersStore,
        //                     roles: { ...roles },
        //                 };
        //             })
        //         );
        // });
    };

    const createNewUser = async () => {
        if (newUser.username && newUser.username !== "" && validPassword) {
            await $user.updateToken().then(async () => {
                ApiClient.getInstance()
                    .userClient.createUser({
                        userCreationRequest: {
                            ...newUser,
                            ...($organisationStore.activeOrgaId && {
                                organisationId: $organisationStore.activeOrgaId,
                            }),
                        },
                        ...($organisationStore.activeOrgaId && {
                            contextOrganisation:
                                $organisationStore.activeOrgaId,
                        }),
                    })
                    .then((result) => {
                        fetching = false;
                        status = true;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
        }
    };

    onMount(() => {
        getRolesPermissionMapping();
    });
</script>

<div class="columns">
    <div class="column is-12">
        <div class="card">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-multiline">
                        <div class="column is-12">
                            <div class="what">Neuer Nutzer</div>
                        </div>
                        <div class="column is-12">
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">Username</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <input
                                                class="input "
                                                type="email"
                                                bind:value={newUser.username}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">E-Mail</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <input
                                                class="input "
                                                type="email"
                                                bind:value={newUser.email}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">Status</label>
                                </div>
                                <div class="field-body">
                                    <div class="select">
                                        <select bind:value={newUser.active}>
                                            <option value={true}>aktiv</option>
                                            <option value={false}
                                                >deaktiviert</option
                                            >
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">Vorname</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <input
                                                class="input "
                                                type="email"
                                                bind:value={newUser.firstName}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">Nachname</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <input
                                                class="input "
                                                type="email"
                                                bind:value={newUser.lastName}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label
                                        for="password"
                                        class="label field-name"
                                    >
                                        Passwort
                                    </label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input {validPassword
                                                    ? ''
                                                    : 'is-danger'}"
                                                type="password"
                                                name="password"
                                                bind:value={newUser.password}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label
                                        for="password-control"
                                        class="label field-name"
                                    >
                                        Passwort wiederholen
                                    </label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input {validPassword
                                                    ? ''
                                                    : 'is-danger'}"
                                                type="password"
                                                name="password-control"
                                                bind:value={passwordControl}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {#if !validPassword}
                                Die Passwörter stimmen nicht überein oder sind
                                nicht lang genug.
                            {/if}
                        </div>

                        <div class="column is-12 ">
                            <div class="columns is-multiline first-row">
                                <div
                                    class="column is-6 is-flex is-justify-content-start"
                                >
                                    <button
                                        class="button gradient-left"
                                        style="float: left;"
                                        on:click={() => navigate(-1)}
                                        >Abbrechen</button
                                    >
                                </div>

                                <div
                                    class="column is-6 is-flex is-justify-content-flex-end"
                                >
                                    <button
                                        class="button gradient-left {fetching
                                            ? 'is-loading'
                                            : ''}"
                                        disabled={newUser.username === "" ||
                                            !validPassword ||
                                            newUser.password.length < 8 ||
                                            passwordControl.length < 8 ||
                                            newUser.password !==
                                                passwordControl}
                                        on:click={() => createNewUser()}
                                        style="float: right;"
                                    >
                                        Erstellen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .field-name {
        text-align: left;
    }
    .what {
        font-weight: 700;
        font-size: 1.7rem;
        padding-bottom: 2rem;
    }

    select {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    ::after {
        border-color: white !important;
    }

    .card {
        border-radius: 100px;
        padding: 2rem 4rem;
    }

    .label {
        text-align: left;
        font-weight: 600 !important;
        font-size: 1.3rem;
        padding-top: 0.375rem;
    }

    .field-label {
        flex-grow: 1.5 !important;
    }
</style>
